import React from "react";
import favicon from "../assets/icon/icon.ico";

const Loader = () => {
  return (
    <div className="text-center">
      <div className="rotate-ring-container">
        <div className="rotate-ring">
          <img src={favicon} alt="Loading" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
